import { FraudAnalysisStatus, FraudRiskLevel } from '~/core/shared/constants';
import { FraudRiskFileAttribute } from '~/core/shared/types';
import { getRiskDisplayConfig } from './getRiskDisplayConfig';

export const getRiskConfig = (fraudRisk?: FraudRiskFileAttribute) => {
  if (!fraudRisk || fraudRisk.status === FraudAnalysisStatus.NotScanned) {
    return {
      ...getRiskDisplayConfig(null),
      displayText: 'Not scanned',
      scoreText: '-',
    };
  }

  if (fraudRisk.status === FraudAnalysisStatus.Failed) {
    return {
      ...getRiskDisplayConfig(FraudRiskLevel.High),
      displayText: 'Error',
      scoreText: '-',
    };
  }

  if (
    fraudRisk.status === FraudAnalysisStatus.Pending ||
    fraudRisk.status === FraudAnalysisStatus.Processing
  ) {
    return {
      ...getRiskDisplayConfig(null),
      displayText: 'Awaiting scan results',
      scoreText: '-',
    };
  }

  return {
    ...getRiskDisplayConfig(fraudRisk.riskLevel),
    displayText: fraudRisk.displayStatus || fraudRisk.riskLevel,
    scoreText:
      fraudRisk.riskScore !== null && fraudRisk.riskScore !== undefined
        ? String(Math.round(fraudRisk.riskScore))
        : '-',
  };
};
